import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FvrZeropaySupportPopupService {

  constructor(
    private httpClient: HttpClient
  ) { }

  private contactEvent = new EventEmitter<void>();

  public async sendMail(form: any) {
    await this.httpClient.post(`https://pub.fevertreefinance.co.za/contact/submit`, form).toPromise();
  }

  public async getTemplate(): Promise<any> {
    return await this.httpClient.get(`https://pub.fevertreefinance.co.za/contact/template`).toPromise();
  }

  public contactDialogEvent = this.contactEvent.asObservable();
  public showContactDialog = () => this.contactEvent.emit();
}
